<script setup lang="ts"></script>

<!-- Need fill color -->
<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.3327 14.0013C27.3327 21.3651 21.3631 27.3346 13.9993 27.3346C6.63555 27.3346 0.666016 21.3651 0.666016 14.0013C0.666016 6.63751 6.63555 0.667969 13.9993 0.667969C21.3631 0.667969 27.3327 6.63751 27.3327 14.0013ZM13.2686 18.3834L18.4583 15.1311C19.292 14.6086 19.292 13.394 18.4583 12.8715L13.2686 9.61916C12.3806 9.06265 11.2272 9.70099 11.2272 10.749V17.2536C11.2272 18.3016 12.3806 18.94 13.2686 18.3834Z"
    />
  </svg>
</template>
